import React, { useState, useEffect } from 'react';
// bootstrap
import { Container } from 'react-bootstrap';
// style
import styled from '@emotion/styled'
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
// dashboardstrcture
import DashboardStructure from '../../general/DashboardStructure';
// modal
import CreateOpportunity from './modal'
// components
import {
    SearchState,
    IntegratedFiltering,
} from '@devexpress/dx-react-grid';
import {
    Grid,
    Table,
    Toolbar,
    SearchPanel,
    TableHeaderRow,
} from '@devexpress/dx-react-grid-bootstrap4';
import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../../general/Buttons';
import clienteAxios from '../../../config/Axios';
import { useSelector } from 'react-redux';




const Create = styled.div`
    position:absolute;
    top:10px;
    right:15px;
    button{
        z-index:99;
    }
`

const TableRow = ({ row, ...restProps }) => {
    const navigate = useNavigate()
    return (
        <Table.Row
            {...restProps}
            // eslint-disable-next-line no-alert
            onClick={() => navigate(`/oportunidad/${row.id}`)}
            style={{
                cursor: 'pointer',
            }}
        />
    )
}

const HighlightedCell = ({ value, style, ...restProps }) => (
    //     nuevo
    // activo
    // inactivo
    // proximamente
    <Table.Cell>
        <span
            style={{
                color: value === "nuevo" ? '#304CC4'
                    : value === "activo" ? '#00C853'
                        : value === "inactivo" ? '#FFAB00'
                            : value === "proximamente" ? '#FF6D00'
                                : '#000000',
                fontWeight: 'bolder',
            }}
        >
            {value}
        </span>
    </Table.Cell>
);

const Cell = (props) => {
    const { column } = props;
    if (column.name === 'status') {
        return <HighlightedCell {...props} />;
    }
    return <Table.Cell {...props} />;
};

const Oportunitties = () => {

    let token = useSelector(state => state.auth.token)

    const [modalShow, setModalShow] = useState(false);
    const [rows, setRows] = useState([]);
    const [update, setUpdate] = useState(1)

    const [columns] = useState([
        { name: 'name', title: 'Oportunidad' },
        { name: 'date', title: 'Fecha de creación' },
        { name: 'status', title: 'Estado' },
    ]);


    useEffect(() => {
        const config = { headers: { 'Authorization': "Bearer " + token } };//confi axios

        clienteAxios.get('/api/oportunities/obtain-oportunities-by-admin', config)
            .then((res) => {
                console.log(res.data)

                let data = []
                for (let i = 0; i < res.data.length; i++) {
                    const element = res.data[i];

                    data.push({
                        name: element.name,
                        date: element.createdAt.split('T')[0],
                        status: element.status,
                        id: element._id
                    })
                }

                setRows(data)
            })
            .catch(error => {
                console.log(error.response)
            })
    }, [update])


    return (
        <DashboardStructure asideRight titlePage="Gestionar - Oportunidades">
            <Container fluid className="p-3 h-100">
                {/* <div className='mb-4'>
                    <PrimaryButton onClick={() => setModalShow(true)}>Crear oportunidad</PrimaryButton>
                </div> */}
                <div className="card h-100">
                    <Grid
                        rows={rows}
                        columns={columns}
                    >
                        <SearchState />
                        <IntegratedFiltering />
                        <Table rowComponent={TableRow} cellComponent={Cell} />
                        <TableHeaderRow />
                        <Toolbar />
                        <Create>
                            <PrimaryButton onClick={() => setModalShow(true)}>Crear Oportunidad</PrimaryButton>
                        </Create>
                        <SearchPanel />
                    </Grid>
                </div>
            </Container>
            <CreateOpportunity
                show={modalShow}
                onHide={() => setModalShow(false)}
                update={update}
                setUpdate={setUpdate}
            />
        </DashboardStructure>
    );
}

export default Oportunitties;